// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"create_wrapper__3BVsD","content":"create_content__2PPUn"};